<template>
  <component
    v-if="view"
    :is="'folder-' + folderTemplateType"
    class="mb-8"
    :list="list"
    :disable-draggable="disableDraggable"
    :show-new="showNew"
    :show-published-date="showPublishedDate"
  />
</template>

<script>
import useBcBookmarkStore from '@/frontapp/store/bcBookmark'
import useBcHomeStore from '@/frontapp/store/bcHome'
import useBcFolderStore from '@/frontapp/store/bcFolder'
import { mapStores } from 'pinia'
import { DocumentApi } from '../test-api/index.ts'
import sortBy from 'lodash/sortBy'
import handleApiError from '../utils/handleApiError'

const documentApi = new DocumentApi({}, '/api/v2')

export default {
  data() {
    return {
      recentlyPublished: [],
      forApproval: [],
    }
  },
  computed: {
    ...mapStores(useBcBookmarkStore, useBcHomeStore, useBcFolderStore),
    folderTemplateType() {
      if (this.view === 'bc-name' || this.bcFolderStore.view === 'grid') return 'grid'
      return 'table'
    },
    views() {
      const ret = [
        {
          name: 'bc-name',
          title: this.$presenter.bcName
        }
      ]

      if (!this.$presenter.isPublic) {
        if (this.bcBookmarkStore.bookmarks.length) {
          ret.push({
            name: 'bookmarks',
            title: this.$t('Pinned')
          })
        }

        if (this.bcHomeStore.recentlyViewedDocuments.length) {
          ret.push({
            name: 'recently-viewed',
            title: this.$t('Recently viewed')
          })
        }
      }

      if (this.recentlyPublished.length) {
        ret.push({
          name: 'recently-published',
          title: this.$t('Recently published')
        })
      }

      if (this.forApproval.length) {
        ret.push({
          name: 'for-approval',
          title: this.$t('Waiting for approval'),
          numOfItems: this.forApproval.length
        })
      }

      return ret
    },
    view() {
      if (this.bcHomeStore.view) {
        return this.bcHomeStore.view
      }

      if (this.views.length) {
        return this.views[0].name
      }

      return null
    },
    list() {
      if (this.view === 'bookmarks') {
        return this.bcBookmarkStore.bookmarks
      }

      if (this.view === 'recently-viewed') {
        if (this.bcHomeStore.order === 'date') {
          return this.bcHomeStore.recentlyViewedDocuments
        } else {
          return sortBy(this.bcHomeStore.recentlyViewedDocuments, 'name')
        }
      }

      if (this.view === 'recently-published') {
        if (this.bcHomeStore.order === 'date') {
          return this.recentlyPublished
        } else {
          return sortBy(this.recentlyPublished, 'name')
        }
      }

      if (this.view === 'for-approval') {
        if (this.bcHomeStore.order === 'date') {
          return this.forApproval
        } else {
          return sortBy(this.forApproval, 'name')
        }
      }

      if (this.view === 'bc-name') {
        return this.bcFolderStore.listChildren[0]
      }

      return []
    },
    disableDraggable() {
      return this.view !== 'bc-name'
    },
    showNew() {
      return this.view === 'bc-name'
    },
    showPublishedDate() {
      return this.view === 'recently-published' && this.folderTemplateType === 'table'
    }
  },
  watch: {
    view: {
      handler: function (newVal) {
        this.bcHomeStore.view = newVal
      },
      immediate: true
    },
    views: {
      handler: function (newVal) {
        this.bcHomeStore.views = newVal
      },
      immediate: true
    },
  },
  methods: {
    async loadRecentlyPublished() {
      const recentlyPublishedResponse =
        await handleApiError(() => documentApi.documentListRecentlyPublished())
      this.recentlyPublished = recentlyPublishedResponse.data
    },
    async loadforApproval() {
      const waitingApprovalResponse =
        await handleApiError(() => documentApi.documentListWaitingApproval())
      this.forApproval = waitingApprovalResponse.data
    }
  },
  mounted() {
    this.bcHomeStore.view = 'bc-name'
    this.loadRecentlyPublished()
    if (!this.$presenter.isPublic) {
      this.loadforApproval()
    }
  },
  unmounted() {
    this.bcHomeStore.view = null
  }
}
</script>
